function noop() {
}
function noopValue(value) {
  return value;
}
export {
  noop,
  noopValue
};
//# sourceMappingURL=noop.js.map
